import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../context/AuthContext';

const Register = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    personalNumber: '',
    password: '',
    confirmPassword: '',
  });
  const [formError, setFormError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { register, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {

    if (isAuthenticated) {
      navigate('/analyses');
    }
  }, [isAuthenticated, navigate]);

  const { name, email, phoneNumber, personalNumber, password, confirmPassword } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setIsSubmitting(true);


    if (!name || !email || !phoneNumber || !personalNumber || !password) {
      setFormError(t('auth.registerError'));
      setIsSubmitting(false);
      return;
    }

    if (password !== confirmPassword) {
      setFormError(t('auth.passwordMismatch'));
      setIsSubmitting(false);
      return;
    }

    if (password.length < 8) {
      setFormError(t('auth.passwordLength'));
      setIsSubmitting(false);
      return;
    }


    const result = await register({
      name,
      email,
      phoneNumber,
      personalNumber,
      password,
    });

    if (result.error) {
      setFormError(result.error);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="container py-5">
      <div className="form-container">
        <h2 className="form-title">{t('auth.register')}</h2>

        {formError && (
          <div className="alert alert-danger" role="alert">
            {formError}
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label htmlFor="name" className="form-label">
              {t('auth.fullName')}
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={name}
              onChange={onChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              {t('auth.email')}
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={email}
              onChange={onChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phoneNumber" className="form-label">
              {t('auth.phoneNumber')}
            </label>
            <input
              type="tel"
              className="form-control"
              id="phoneNumber"
              name="phoneNumber"
              value={phoneNumber}
              onChange={onChange}
              required
              dir="ltr"
              style={{ textAlign: 'left' }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="personalNumber" className="form-label">
              {t('auth.personalNumber')}
            </label>
            <input
              type="text"
              className="form-control"
              id="personalNumber"
              name="personalNumber"
              value={personalNumber}
              onChange={onChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              {t('auth.password')}
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              value={password}
              onChange={onChange}
              required
              minLength="8"
            />
            <small className="form-text text-muted">
              {t('auth.passwordLength')}
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword" className="form-label">
              {t('auth.confirmPassword')}
            </label>
            <input
              type="password"
              className="form-control"
              id="confirmPassword"
              name="confirmPassword"
              value={confirmPassword}
              onChange={onChange}
              required
            />
          </div>

          <button
            type="submit"
            className="form-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {t('auth.loading')}
              </>
            ) : (
              t('auth.register')
            )}
          </button>
        </form>

        <Link to="/login" className="form-link">
          {t('auth.haveAccount')}
        </Link>
      </div>
    </div>
  );
};

export default Register;
